import React from 'react';
import { reduxForm } from 'redux-form';

import Aux from '../../common/Aux';
import Button from '../../common/form/Button';
import { ButtonGroup, InputFieldGroup } from '../../common/form';
import Spinner from '../../common/loaders/Spinner';
import Card from '../../common/Card';

const UserForm = ({ handleSubmit, onSubmit, submitting, errorMessage }) => {
	return (
		<Aux>
			{ submitting && <Spinner /> }
			<form onSubmit={handleSubmit(onSubmit)} className="settings__form">

				<InputFieldGroup 
					label="First Name"
					name="firstName"
				/>
				
				<InputFieldGroup 
					label="Last Name"
					name="lastName"
				/>
				
				<InputFieldGroup 
					label="Email"
					name="email"
					type="email"
				/>

				<InputFieldGroup 
					label="Username"
					name="username"
					custom={{readOnly: true}}
				/>

				{ errorMessage && 
					<div className="password__error">
						<Card 
							color="error" 
							shadow={false}
							materialIcon="error">
							{errorMessage}
						</Card>
					</div> 
				}

				<ButtonGroup>
					<Button color="secondary">Update</Button>
				</ButtonGroup>
			</form>
		</Aux>
	);
};

const validate = values => {
	const errors = {};

	if (!values.firstName) {
		errors.firstName = "You must provide a First Name.";
	}

	if (!values.lastName) {
		errors.lastName = "You must provide a Last Name.";
	}

	if (!values.email) {
		errors.email = "You must provide an Email Address.";
	}

	return errors;
}

export default reduxForm({
	form: 'userForm',
	validate,
})(UserForm);


// WEBPACK FOOTER //
// ./src/components/routes/Settings/UserForm.js